import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Grid } from '@chakra-ui/react';
import React, { useState, useEffect, useRef } from 'react';
import { Button } from '../../components/button/button';
import { Checkbox } from '../../components/checkbox/checkbox';
import { DataGrid } from '../../components/data-grid/data-grid';
import Input from '../../components/input/input';
import { Select } from '../../components/select/select';
import { ButtonSize, ButtonVariant } from '../../core/enums';
import theme from '../../theme';
import { SubHeader } from '../organizations/subheader';
import { ACCOUNT_INFORMATION, ACTIVE, CHANGE_PASSWORD, FORCE_PASSWORD_CHANGE, LOCKED, PASSWORD_CHANGE_DESC, PASSWORD_OPTIONS, ROLES } from './user-detail-constants';
import { styles } from './user-detail-styles';
import { DeleteIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { ModalComponent } from '../../components/Modal/modal';
import EventEmitter from 'events';
const gridOptions = {
    suppressHorizontalScroll: true,
    suppressPaginationPanel: true,
    paginationPageSizeSelector: false,
    domLayout: 'autoHeight'
};
export const UserDetail = (props)=>{
    const { availableOrganizations, availableRoles, dispatchNavigation, save, formErrors, errors, selectedUser, editPermission, passwordModalOpen, ssoConfiguration, togglePasswordModal, toggleShowErrors } = props;
    const eventEmitter = useRef(new EventEmitter());
    const roleOptions = [];
    const organizationOptions = [];
    availableRoles?.forEach((item)=>{
        const option = {
            value: item?.id,
            label: item?.roleName
        };
        roleOptions.push(option);
    });
    availableOrganizations?.forEach((item)=>{
        const option = {
            value: item?.tenantId,
            label: item?.displayName ?? ''
        };
        organizationOptions.push(option);
    });
    const [selectedRole, setSelectedRole] = useState();
    const [selectedOrg, setSelectedOrg] = useState();
    const [forcePasswordChange, setNewPasswordChange] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [newSelectedUser, setNewSelectedUser] = useState({
        ...props.selectedUser
    });
    const [modalPassword, setNewModalPassword] = useState({
        password: '',
        confirmPassword: ''
    });
    const [isNewUser, setIsNewUser] = useState(false);
    const toggleForcePasswordChange = (e)=>{
        setNewPasswordChange(!forcePasswordChange);
        setNewSelectedUser({
            ...newSelectedUser,
            forcePasswordChange: !forcePasswordChange
        });
    };
    const handleInputChange = (event)=>{
        const target = event.target;
        const { value, name } = target;
        setNewSelectedUser({
            ...newSelectedUser,
            [name]: value
        });
    };
    const handleModalInputChange = (event)=>{
        const target = event.target;
        const { value, name } = target;
        setNewModalPassword({
            ...modalPassword,
            [name]: value
        });
    };
    const onRoleSelect = (event)=>{
        const target = event.target;
        const { value, textContent } = target;
        setSelectedRole({
            id: parseInt(value),
            roleName: textContent ?? ''
        });
    };
    const onOrganizationSelect = (event)=>{
        const target = event.target;
        const { value, textContent } = target;
        setSelectedOrg({
            orgName: textContent ?? '',
            tenantId: value
        });
    };
    const onAddClick = ()=>{
        const existingRoles = [
            ...newSelectedUser.roles
        ];
        const index = Object.entries(existingRoles).map((item)=>item[1].tenantId).indexOf(selectedOrg?.tenantId);
        const currentRole = availableRoles?.filter((item)=>{
            return item.id === selectedRole?.id;
        });
        if (index >= 0) {
            const existingOrg = Object.entries(existingRoles)[index][1];
            existingOrg?.roles.push(currentRole[0]);
            const newEntry = {
                organizationName: existingOrg?.organizationName,
                tenantId: existingOrg.tenantId,
                displayName: existingOrg.displayName ? existingOrg.displayName : existingOrg.organizationName,
                ...currentRole[0]
            };
            setRowData([
                ...rowData,
                newEntry
            ]);
        } else {
            const currentOrg = availableOrganizations.filter((item)=>{
                return item.tenantId === selectedOrg?.tenantId;
            });
            if (currentOrg && currentRole) {
                const role = {
                    tenantId: currentOrg[0]?.tenantId,
                    organizationName: currentOrg[0]?.organizationName,
                    roles: currentRole,
                    displayName: currentOrg[0]?.displayName || ''
                };
                existingRoles.push(role);
            }
            const newEntry = {
                organizationName: currentOrg[0]?.organizationName,
                tenantId: currentOrg[0].tenantId,
                displayName: currentOrg[0].displayName ? currentOrg[0].displayName : currentOrg[0].organizationName,
                ...currentRole[0]
            };
            setRowData([
                ...rowData,
                newEntry
            ]);
        }
        setNewSelectedUser({
            ...newSelectedUser,
            roles: [
                ...existingRoles
            ]
        });
    };
    const addButtonStatus = ()=>{
        if (selectedRole?.roleName?.trim().length && selectedOrg?.orgName.trim().length) {
            const temp = rowData.filter((item)=>{
                return item.tenantId === selectedOrg.tenantId && item.id === selectedRole.id;
            });
            if (temp.length > 0) {
                return true;
            }
            return false;
        }
        return true;
    };
    const _handleFormSubmit = ()=>{
        if (newSelectedUser.ssoIndicator) {
            save(props.auth, {
                ...newSelectedUser,
                password: null,
                forcePasswordChange: false
            });
        } else {
            save(props.auth, newSelectedUser);
        }
    };
    const _handleChangePasswordSubmit = ()=>{
        save(props.auth, {
            ...newSelectedUser,
            password: modalPassword.password,
            confirmPassword: modalPassword.confirmPassword
        });
    };
    const saveButtonStatus = ()=>{
        const { firstName, lastName, password, confirmPassword, roles, ssoIndicator } = newSelectedUser;
        if (isNewUser) {
            const passwordOrSSO = password?.trim().length && confirmPassword?.trim().length || ssoIndicator;
            if (firstName.trim().length && lastName.trim().length && passwordOrSSO && roles.length > 0 && rowData.length > 0) {
                return false;
            }
        } else {
            if (firstName.trim().length && lastName.trim().length && roles.length > 0 && rowData.length > 0) {
                return false;
            }
        }
        return true;
    };
    const modalSubmitStatus = ()=>{
        if (modalPassword.password.trim().length > 0 && modalPassword.confirmPassword.trim().length > 0) {
            return false;
        }
        return true;
    };
    const buildRowData = (roles)=>{
        const newData = [];
        roles.forEach((org)=>{
            org.roles.forEach((role)=>{
                newData.push({
                    organizationName: org.organizationName,
                    tenantId: org.tenantId,
                    displayName: org.displayName ? org.displayName : org.organizationName,
                    ...role
                });
            });
        });
        setRowData(newData);
    };
    const hasError = (key, errors)=>{
        return errors && key in errors;
    };
    const getInlineError = (errors)=>{
        return errors.join(' ');
    };
    const displayErrorIfPresent = (key, errors)=>{
        return hasError(key, errors) ? getInlineError(errors[key]) : '';
    };
    const roleErrors = Object.entries(formErrors?.fieldErrors).map(([field, message])=>{
        return field === 'roles' ? message : null;
    });
    const clearModalErrors = ()=>{
        props.toggleShowErrors(false);
    };
    const setPasswordModalStatus = (isOpen)=>{
        setNewModalPassword({
            password: '',
            confirmPassword: ''
        });
        togglePasswordModal(isOpen);
    };
    const handleDeleteRole = (field)=>{
        const { data } = field;
        const index = rowData.findIndex((item)=>item.tenantId === data.tenantId && item.roleName === data.roleName);
        if (index >= 0) {
            const selectedUserRoles = [
                ...newSelectedUser.roles
            ];
            const selectedUserIndex = selectedUserRoles.findIndex((item)=>item.tenantId === data.tenantId);
            if (selectedUserIndex >= 0) {
                if (selectedUserRoles[selectedUserIndex].roles.length > 1) {
                    const roleIndex = selectedUserRoles[selectedUserIndex].roles.findIndex((item)=>item.roleName === data.roleName);
                    if (roleIndex >= 0) {
                        selectedUserRoles[selectedUserIndex].roles.splice(roleIndex, 1);
                    }
                } else {
                    selectedUserRoles.splice(selectedUserIndex, 1);
                }
                const newRowData = [
                    ...rowData
                ];
                newRowData.splice(index, 1);
                setRowData([
                    ...newRowData
                ]);
                setNewSelectedUser({
                    ...newSelectedUser,
                    roles: [
                        ...selectedUserRoles
                    ]
                });
            }
        }
    };
    useEffect(()=>{
        const isNew = selectedUser.id === null;
        toggleShowErrors(false);
        togglePasswordModal(false);
        setIsNewUser(isNew);
        if (isNew) {
            setNewSelectedUser({
                ...selectedUser,
                forcePasswordChange: true
            });
        } else if (selectedUser.roles) {
            buildRowData(selectedUser.roles);
        }
    // eslint-disable-next-line
    }, [
        selectedUser
    ]);
    const colDefs = [
        {
            headerName: 'Role',
            field: 'roleName'
        },
        {
            headerName: 'Organization',
            field: 'organizationName'
        },
        {
            headerName: 'Remove',
            field: 'delete',
            cellRenderer: (field)=>{
                return /*#__PURE__*/ _jsx(DeleteIcon, {
                    onClick: (event)=>eventEmitter.current.emit('deleteClick', field)
                });
            }
        }
    ];
    eventEmitter.current.once('deleteClick', (evnt)=>{
        handleDeleteRole(evnt);
    });
    const classes = styles();
    return /*#__PURE__*/ _jsxs(Grid, {
        sx: classes.root,
        children: [
            /*#__PURE__*/ _jsx(SubHeader, {
                title: isNewUser ? 'Add User' : 'Edit User',
                href: '/cmx/admin/users/',
                handleAnchorElementClick: dispatchNavigation,
                anchorButtonVariant: ButtonVariant.LINKS,
                anchorButtonName: 'Cancel',
                actionName: 'Save',
                onActionClick: _handleFormSubmit,
                isActionDisabled: saveButtonStatus(),
                className: classes.text
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                sx: classes.fieldsets,
                children: [
                    /*#__PURE__*/ _jsxs("fieldset", {
                        style: classes.fieldset,
                        children: [
                            /*#__PURE__*/ _jsx("legend", {
                                style: classes.legend,
                                children: ACCOUNT_INFORMATION
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                sx: classes.accountinformation,
                                children: [
                                    /*#__PURE__*/ _jsx(Input, {
                                        placeholder: 'Eg:name@example.com',
                                        isRequired: true,
                                        textInfo: 'The email address of the user.',
                                        onChange: handleInputChange,
                                        label: 'Username',
                                        name: 'username',
                                        textError: displayErrorIfPresent('username', formErrors.fieldErrors),
                                        dataTestId: 'userNameInput',
                                        isError: hasError('username', formErrors.fieldErrors),
                                        isReadOnly: !isNewUser,
                                        value: newSelectedUser.username
                                    }),
                                    !isNewUser && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            editPermission && /*#__PURE__*/ _jsxs(Flex, {
                                                style: classes.checkBox,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: classes.checkBoxWidth,
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                ACTIVE,
                                                                ' ',
                                                                /*#__PURE__*/ _jsxs("span", {
                                                                    style: {
                                                                        color: theme.colors.success[500]
                                                                    },
                                                                    children: [
                                                                        ' ',
                                                                        "*"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Checkbox, {
                                                        label: '',
                                                        isChecked: newSelectedUser.active,
                                                        name: 'activeCheckBox',
                                                        dataTestId: 'activeCheckBox',
                                                        onChange: ()=>{
                                                            setNewSelectedUser({
                                                                ...newSelectedUser,
                                                                active: !newSelectedUser.active
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Flex, {
                                                style: classes.checkBox,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: classes.checkBoxWidth,
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                LOCKED,
                                                                " "
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Checkbox, {
                                                        label: '',
                                                        isChecked: newSelectedUser.locked,
                                                        name: 'activeLocked',
                                                        dataTestId: 'lockedCheckBox',
                                                        onChange: ()=>{
                                                            setNewSelectedUser({
                                                                ...newSelectedUser,
                                                                locked: !newSelectedUser.locked
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (editPermission || ssoConfiguration) && /*#__PURE__*/ _jsxs(Flex, {
                                        style: classes.checkBox,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                style: classes.checkBoxWidth,
                                                children: /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        "SSO",
                                                        ' ',
                                                        /*#__PURE__*/ _jsx("span", {
                                                            style: {
                                                                color: theme.colors.success[500]
                                                            },
                                                            children: " "
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Checkbox, {
                                                label: '',
                                                isChecked: newSelectedUser.ssoIndicator,
                                                name: 'ssoCheckBox',
                                                dataTestId: 'ssoCheckBox',
                                                onChange: ()=>{
                                                    setNewSelectedUser({
                                                        ...newSelectedUser,
                                                        ssoIndicator: !newSelectedUser.ssoIndicator
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Input, {
                                        isRequired: true,
                                        onChange: handleInputChange,
                                        label: 'First Name',
                                        placeholder: 'Enter first name',
                                        name: 'firstName',
                                        textError: displayErrorIfPresent('firstName', formErrors.fieldErrors),
                                        dataTestId: 'firstNameInput',
                                        isError: hasError('firstName', formErrors.fieldErrors),
                                        value: newSelectedUser.firstName
                                    }),
                                    /*#__PURE__*/ _jsx(Input, {
                                        isRequired: true,
                                        onChange: handleInputChange,
                                        label: 'Last Name',
                                        placeholder: 'Enter last name',
                                        name: 'lastName',
                                        textError: displayErrorIfPresent('lastName', formErrors.fieldErrors),
                                        dataTestId: 'lastNameInput',
                                        isError: hasError('lastName', formErrors.fieldErrors),
                                        value: newSelectedUser.lastName
                                    }),
                                    isNewUser && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Input, {
                                                isRequired: true,
                                                onChange: handleInputChange,
                                                label: 'Password',
                                                placeholder: 'Enter password',
                                                type: 'password',
                                                name: 'password',
                                                textError: displayErrorIfPresent('password', formErrors.fieldErrors),
                                                dataTestId: 'passwordInput',
                                                isError: hasError('password', formErrors.fieldErrors),
                                                isDisabled: newSelectedUser.ssoIndicator
                                            }),
                                            /*#__PURE__*/ _jsx(Input, {
                                                isRequired: true,
                                                onChange: handleInputChange,
                                                label: 'Confirm',
                                                placeholder: 'Enter confirm password',
                                                type: 'password',
                                                name: 'confirmPassword',
                                                textError: displayErrorIfPresent('confirmPassword', formErrors.fieldErrors),
                                                dataTestId: 'confirmPasswordInput',
                                                isError: hasError('confirmPassword', formErrors.fieldErrors),
                                                isDisabled: newSelectedUser.ssoIndicator
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isNewUser && !newSelectedUser.ssoIndicator && /*#__PURE__*/ _jsxs("fieldset", {
                        style: classes.fieldset,
                        children: [
                            /*#__PURE__*/ _jsx("legend", {
                                style: classes.legend,
                                children: PASSWORD_OPTIONS
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                sx: classes.passwordoptions,
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        children: FORCE_PASSWORD_CHANGE
                                    }),
                                    /*#__PURE__*/ _jsx(Checkbox, {
                                        label: '',
                                        dataTestId: 'forcePasswordChangeCheckBox',
                                        isChecked: forcePasswordChange,
                                        onChange: toggleForcePasswordChange,
                                        name: "passwordCheckbox",
                                        isDisabled: newSelectedUser.ssoIndicator
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: PASSWORD_CHANGE_DESC
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("fieldset", {
                        style: classes.fieldset,
                        children: [
                            /*#__PURE__*/ _jsxs("legend", {
                                style: classes.legend,
                                children: [
                                    ROLES,
                                    /*#__PURE__*/ _jsx("span", {
                                        style: classes.span,
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Grid, {
                                sx: classes.roles,
                                children: [
                                    rowData.length > 0 && /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx(DataGrid, {
                                            rowData: rowData,
                                            columnDefs: colDefs,
                                            gridOptions: gridOptions,
                                            height: "auto"
                                        })
                                    }),
                                    !rowData.length && /*#__PURE__*/ _jsx("div", {
                                        className: "no-roles-selected",
                                        children: "There are no roles associated with this user. Add some using the form below."
                                    }),
                                    /*#__PURE__*/ _jsxs(Grid, {
                                        templateColumns: "0.15fr 1fr 0.0fr 1fr 0.2fr",
                                        gap: 5,
                                        alignItems: 'center',
                                        marginTop: 5,
                                        children: [
                                            /*#__PURE__*/ _jsx("h1", {
                                                children: "Add as an"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                placeholder: "choose role",
                                                items: roleOptions,
                                                value: selectedRole?.roleName,
                                                onChange: onRoleSelect,
                                                dataTestId: 'roleSelect'
                                            }),
                                            /*#__PURE__*/ _jsx("h1", {
                                                children: "at"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                placeholder: "choose organization",
                                                items: organizationOptions,
                                                value: selectedOrg?.orgName,
                                                onChange: onOrganizationSelect,
                                                dataTestId: 'organizationSelect'
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: ButtonVariant.SECONDARY,
                                                label: 'Add',
                                                size: ButtonSize.XS,
                                                onClick: onAddClick,
                                                disabled: addButtonStatus(),
                                                height: '10',
                                                width: '20',
                                                name: 'addRoleButton',
                                                dataTestId: 'addRoleButton'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isNewUser && editPermission && !newSelectedUser.ssoIndicator && /*#__PURE__*/ _jsxs("fieldset", {
                        style: classes.fieldset,
                        children: [
                            /*#__PURE__*/ _jsx("legend", {
                                style: classes.legend,
                                children: CHANGE_PASSWORD
                            }),
                            /*#__PURE__*/ _jsx(Flex, {
                                flexDirection: 'row',
                                alignItems: 'center',
                                margin: '20',
                                children: /*#__PURE__*/ _jsx(Button, {
                                    label: 'Change Password',
                                    onClick: ()=>{
                                        setPasswordModalStatus(true);
                                    },
                                    name: 'changePasswordButton',
                                    dataTestId: 'changePasswordButton',
                                    isDisabled: newSelectedUser.ssoIndicator
                                })
                            })
                        ]
                    }),
                    passwordModalOpen && !newSelectedUser.ssoIndicator && /*#__PURE__*/ _jsx(ModalComponent, {
                        size: 'xl',
                        isOpen: passwordModalOpen,
                        handleClose: ()=>{
                            setPasswordModalStatus(false);
                        },
                        showCloseIcon: true,
                        modalHeader: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                "Change Password for ",
                                newSelectedUser.username
                            ]
                        }),
                        modalContent: /*#__PURE__*/ _jsxs(Flex, {
                            flexDirection: 'column',
                            rowGap: 6,
                            children: [
                                /*#__PURE__*/ _jsx(Flex, {
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        label: 'New Password',
                                        onChange: handleModalInputChange,
                                        placeholder: 'Enter new password',
                                        name: 'password',
                                        isRequired: true,
                                        textError: displayErrorIfPresent('password', formErrors.fieldErrors),
                                        dataTestId: 'newPasswordInput',
                                        type: 'password',
                                        isError: hasError('password', formErrors.fieldErrors)
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Flex, {
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        label: 'Confirm New Password',
                                        onChange: handleModalInputChange,
                                        name: 'confirmPassword',
                                        placeholder: 'Enter confirm password',
                                        isRequired: true,
                                        textError: displayErrorIfPresent('confirmPassword', formErrors.fieldErrors),
                                        dataTestId: 'confirmNewPasswordInput',
                                        type: 'password',
                                        isError: hasError('confirmPassword', formErrors.fieldErrors)
                                    })
                                })
                            ]
                        }),
                        modalFooter: /*#__PURE__*/ _jsx(Flex, {
                            alignItems: 'flex-end',
                            children: /*#__PURE__*/ _jsx(Button, {
                                label: 'Submit',
                                onClick: _handleChangePasswordSubmit,
                                disabled: modalSubmitStatus(),
                                dataTestId: 'passwordModalSubmitButton'
                            })
                        })
                    }),
                    errors ? /*#__PURE__*/ _jsx(ModalComponent, {
                        isOpen: errors,
                        handleClose: clearModalErrors,
                        size: "xl",
                        modalHeader: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(WarningTwoIcon, {}),
                                " Error",
                                ' '
                            ]
                        }),
                        modalContent: /*#__PURE__*/ _jsx("div", {
                            children: Object.values(roleErrors).map((errorList)=>{
                                return errorList?.map((error)=>{
                                    return /*#__PURE__*/ _jsx("p", {
                                        children: error
                                    }, `${error}`);
                                });
                            })
                        }),
                        modalFooter: /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ _jsx(Button, {
                                label: 'Return',
                                onClick: clearModalErrors,
                                dataTestId: 'errorModalReturnButton',
                                name: 'returnButton',
                                children: "Secondary Action"
                            })
                        })
                    }) : null
                ]
            })
        ]
    });
};
